import React from 'react'

export default function SubmittedPage({ t, isApproved, isClient }) {
  return (
    <div className="approve-submitted-message">
      <div className="approve-submitted-message-icon">
        <span>
          <i className="fas fa-check" />
        </span>
      </div>
      <div className="approve-submitted-message-content">
        <h2>{t('approve.submittedMessageTitle')}</h2>
        {isApproved ? (
          <div>
            <p>
              {isClient
                ? t('approve.submittedMessageContentApprovedCustomer')
                : t('approve.submittedMessageContentApproved')}
            </p>
            <a href={`https://nps.trustmary.com/${isClient ? 'tjBy8rvhj' : 'svIgrE9OB'}`}>
              {t('approve.submittedMessageContentApprovedLink')}
            </a>
          </div>
        ) : (
          <p>{t('approve.submittedMessageContent')}</p>
        )}
      </div>
    </div>
  )
}
